import { forwardRef, type SVGProps } from 'react';

export const ShipToIconLight = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ShipToIconLight(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 37 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M25 18L31 12L25 6V18Z" fill="#0C3260" />
      <path
        clipRule="evenodd"
        d="M7 18.8719H11.4094C11.4094 19.7344 11.7094 20.4703 12.3094 21.0797C12.9094 21.6891 13.6406 21.9937 14.5031 21.9937C15.3844 21.9937 16.1297 21.6891 16.7391 21.0797C17.3484 20.4703 17.6531 19.7344 17.6531 18.8719H19.4812V14.7937L15.5156 9.47813H12.8437V5.0625H7V6.32812H11.5781V17.5781H7V18.8719ZM15.825 20.1656C15.4688 20.5219 15.0375 20.7 14.5312 20.7C14.0062 20.7 13.5656 20.5219 13.2094 20.1656C12.8531 19.8094 12.675 19.3781 12.675 18.8719C12.675 18.3656 12.8531 17.9297 13.2094 17.5641C13.5656 17.1984 14.0062 17.0156 14.5312 17.0156C15.0375 17.0156 15.4688 17.1984 15.825 17.5641C16.1812 17.9297 16.3594 18.3656 16.3594 18.8719C16.3594 19.3781 16.1812 19.8094 15.825 20.1656ZM18.2156 15.2156H12.8437V10.7719H14.8687L18.2156 15.2156Z"
        fill="#0C3260"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6 18.8719H11.4094C11.4094 19.7344 11.7094 20.4703 12.3094 21.0797C12.9094 21.6891 13.6406 21.9937 14.5031 21.9937C15.3844 21.9937 16.1297 21.6891 16.7391 21.0797C17.3484 20.4703 17.6531 19.7344 17.6531 18.8719H19.4813V14.7937L15.5156 9.47813H12.8438V5.0625L6 5.0625V6.32813H11.5781V17.5781H6V18.8719ZM15.825 20.1656C15.4688 20.5219 15.0375 20.7 14.5313 20.7C14.0063 20.7 13.5656 20.5219 13.2094 20.1656C12.8531 19.8094 12.675 19.3781 12.675 18.8719C12.675 18.3656 12.8531 17.9297 13.2094 17.5641C13.5656 17.1984 14.0063 17.0156 14.5313 17.0156C15.0375 17.0156 15.4688 17.1984 15.825 17.5641C16.1813 17.9297 16.3594 18.3656 16.3594 18.8719C16.3594 19.3781 16.1813 19.8094 15.825 20.1656ZM18.2156 15.2156H12.8438V10.7719H14.8688L18.2156 15.2156Z"
        fill="#0C3260"
        fillRule="evenodd"
      />
    </svg>
  );
});
